import PropTypes from 'prop-types';
import { Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

// Inline search field used in workstation page headers: a bordered row holding a
// magnifier and a borderless input, accented while focused.
const SearchInput = ({
	value,
	onChange,
	placeholder = 'Search…',
	disabled = false,
	minWidth = 230,
	'data-testid': dataTestId = 'search-input',
}) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			gap: '6px',
			padding: '1px 10px',
			minWidth,
			borderRadius: '7px',
			border: '0.5px solid',
			borderColor: 'border.main',
			backgroundColor: 'background.paper',
			transition: 'border-color .12s ease',
			'&:focus-within': { borderColor: 'primary.main' },
		}}
	>
		<SearchIcon
			data-testid='search-icon'
			sx={{ fontSize: 15, color: 'text.tertiary', flexShrink: 0 }}
		/>
		<InputBase
			data-testid={dataTestId}
			value={value}
			onChange={onChange}
			placeholder={placeholder}
			disabled={disabled}
			fullWidth
			sx={{
				fontSize: 12,
				color: 'text.primary',
				'& input::placeholder': { color: 'text.tertiary', opacity: 1 },
			}}
		/>
	</Box>
);

SearchInput.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	'data-testid': PropTypes.string,
};

export default SearchInput;
